import { ColorName } from './types'

/**
 * Colors reference for card theming
 * Based on Skedulo design system color palette
 */
export const colors: Record<ColorName, Record<string, string>> = {
  transparent: {
    transparent: 'transparent',
  },
  white: {
    white: 'white',
  },
  neutral: {
    '900': '#1B263A',
    '850': '#223049',
    '800': '#364359',
    '750': '#4A556A',
    '700': '#5E687A',
    '650': '#697282',
    '200': '#F3F5F9',
  },
  green: {
    '900': '#3E7F4D',
    '800': '#479258',
    '700': '#50A463',
    '600': '#59B66E',
    '200': '#DEF0E2',
    '100': '#EEF8F1',
  },
  orange: {
    '900': '#9F5314',
    '800': '#B65E16',
    '700': '#CC6A19',
    '600': '#E3761C',
    '200': '#F9E4D2',
    '100': '#FCF1E8',
  },
  yellow: {
    '900': '#A1850B',
    '800': '#B8980C',
    '700': '#CFAB0E',
    '600': '#E6BE0F',
    '200': '#FAF2CF',
    '100': '#FDF9E7',
  },
  red: {
    '900': '#952A22',
    '800': '#AA3026',
    '700': '#C0362B',
    '600': '#D53C30',
    '200': '#F7D8D6',
    '100': '#FBECEA',
  },
  purple: {
    '900': '#514192',
    '800': '#5C4AA6',
    '700': '#6854BB',
    '600': '#735DD0',
    '200': '#E3DFF6',
    '100': '#F1EFFA',
  },
  cyan: {
    '900': '#29768D',
    '800': '#2E87A2',
    '700': '#3498B6',
    '600': '#3AA9CA',
    '200': '#D8EEF4',
    '100': '#EBF6FA',
  },
  teal: {
    '900': '#19675F',
    '800': '#1D766C',
    '700': '#20847A',
    '600': '#249387',
    '200': '#D3E9E7',
    '100': '#E9F4F3',
  },
  pink: {
    '900': '#832358',
    '800': '#962864',
    '700': '#A82D71',
    '600': '#BB327D',
    '200': '#F1D6E5',
    '100': '#F8EBF2',
  },
  indigo: {
    '900': '#2F3976',
    '800': '#364286',
    '700': '#3C4A97',
    '600': '#4352A8',
    '200': '#D9DCEE',
    '100': '#ECEEF6',
  },
  lime: {
    '900': '#577D2E',
    '800': '#638F35',
    '700': '#70A13B',
    '600': '#7CB342',
    '200': '#E5F0D9',
    '100': '#F2F7EC',
  },
  maroon: {
    '900': '#4F2B3F',
    '800': '#5A3248',
    '700': '#663851',
    '600': '#713E5A',
    '200': '#E3D8DE',
    '100': '#F1ECEF',
  },
  sapphire: {
    '900': '#3E6682',
    '800': '#4F83A7',
    '700': '#4F83A7',
    '600': '#5891BA',
    '200': '#DEE9F1',
    '100': '#EEF4F8',
  },
  rose: {
    '900': '#89374A',
    '800': '#9D3F55',
    '700': '#B0475F',
    '600': '#C44F6A',
    '200': '#F3DCE1',
    '100': '#F9EDF0',
  },
}
